import { render, staticRenderFns } from "./addCompanyBankCard.vue?vue&type=template&id=22590433&scoped=true"
import script from "./addCompanyBankCard.vue?vue&type=script&lang=js"
export * from "./addCompanyBankCard.vue?vue&type=script&lang=js"
import style0 from "./addCompanyBankCard.vue?vue&type=style&index=0&id=22590433&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22590433",
  null
  
)

export default component.exports